import { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import pagesData from "./pagesData";
import DynamicPage from "./pages/DynamicPage";
import "./style.css";
import "./global.css";
import Home from "./pagesData/home";
import WhatsNewDialog from "./components/WhatsNewDialog";

function AppContent() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const location = useLocation();
  const version = "v2.0.3"; // Update this when you have new features

  // Check if user should see What's New dialog
  useEffect(() => {
    const hasSeenWhatsNew = localStorage.getItem('hasSeenWhatsNew');
    const currentVersion = version;
    const lastSeenVersion = localStorage.getItem('lastSeenVersion');

    // Show dialog if:
    // 1. User is on homepage AND
    // 2. Haven't seen it before OR there's a new version
    if (location.pathname === '/' && (!hasSeenWhatsNew || lastSeenVersion !== currentVersion)) {
      // Small delay to ensure page has loaded
      const timer = setTimeout(() => {
        setShowWhatsNew(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  const handleCloseWhatsNew = () => {
    setShowWhatsNew(false);
    const currentVersion = version;
    localStorage.setItem('hasSeenWhatsNew', 'true');
    localStorage.setItem('lastSeenVersion', currentVersion);
  };

  const handleOpenWhatsNew = () => {
    setShowWhatsNew(true);
  };

  return (
    <div className="flex flex-col min-h-screen dark:bg-color-gray-800 dark:text-color-white">
      <Header 
        onMenuClick={() => setDrawerOpen(open => !open)} 
        onWhatsNewClick={handleOpenWhatsNew}
        version={version}
      />
      <div className="block md:flex grow">
        {/* Desktop Sidebar */}
        <div className="hidden lg:block">
          <Sidebar />
        </div>
        {/* Mobile Drawer Sidebar */}
        <div className={`fixed inset-0 z-50 flex lg:hidden transition-all ${drawerOpen ? "left-0 visible" : "-left-full invisible"}`}>
          <div className="w-64 bg-white dark:bg-color-gray-900 shadow-lg h-full">
            <Sidebar onMenuClick={() => setDrawerOpen(open => !open)} />
          </div>
          <div
            className={`flex-1 bg-color-black/40 ${drawerOpen ? "opacity-100" : "opacity-0 "}`}
            onClick={() => setDrawerOpen(false)}
            aria-label="Close sidebar"
          />
        </div>
        <div className="grow">
          <main className="">
            <Routes>
              <Route path="/" element={<Home />} />
                {pagesData.flatMap(section =>
                  section.pages.map(page => (
                    <Route
                      key={page.path}
                      path={page.path}
                      element={<DynamicPage pageName={page.name} />}
                    />
                  ))
                )}
            </Routes>
          </main>
          <footer className="border-t border-color-gray-200 dark:border-color-gray-700 lg:py-7 py-4 text-center text-xs text-color-gray-700 dark:text-color-gray-400">
            Copyright @ 2025 Unicss
          </footer>
        </div>
      </div>

      {/* What's New Dialog */}
      <WhatsNewDialog 
        isOpen={showWhatsNew} 
        onClose={handleCloseWhatsNew} 
      />
    </div>
  );
}

function App() {
  return (
    <Router basename="/">
      <AppContent />
    </Router>
  );
}

export default App;